export function scheduleAfterInteractive(task: () => void, delay = 250) {
  if (typeof window === "undefined") {
    const timer = setTimeout(task, delay);
    return () => clearTimeout(timer);
  }

  let timeout: number | undefined;
  let idle: number | undefined;
  const run = () => {
    timeout = window.setTimeout(task, delay);
  };
  if (window.requestIdleCallback) {
    idle = window.requestIdleCallback(run, { timeout: 1_500 });
  } else {
    run();
  }
  return () => {
    if (idle !== undefined) window.cancelIdleCallback(idle);
    if (timeout !== undefined) window.clearTimeout(timeout);
  };
}
